'use client';

import { useEffect } from 'react';

import { Center, Spinner } from '@chakra-ui/react';

import { handlePageScroll } from 'utils/pageScroll';

type LoaderProps = {
  fixed?: boolean;
  absolute?: boolean;
  bg?: string;
  containerProps?: Record<string, unknown>;
};

const Loader = ({
  fixed,
  absolute,
  bg = 'transparent',
  containerProps = {}
}: LoaderProps) => {
  useEffect(() => {
    if (fixed) {
      handlePageScroll(true);
      return () => {
        handlePageScroll(false);
      };
    }
  }, [fixed]);

  if (fixed) {
    return (
      <Center
        position='fixed'
        top={0}
        left={0}
        width='100vw'
        height='100vh'
        color='primary.main'
        bg={bg}
        zIndex={1000}
        {...containerProps}
      >
        <Spinner
          size='lg'
          thickness='4px'
          speed='0.65s'
          emptyColor='primary.100'
        />
      </Center>
    );
  }

  if (absolute) {
    return (
      <Center
        position='absolute'
        top={0}
        left={0}
        width='100%'
        height='100%'
        color='primary.main'
        zIndex={100}
        bg={bg}
        {...containerProps}
      >
        <Spinner
          size='lg'
          thickness='4px'
          speed='0.65s'
          emptyColor='primary.100'
        />
      </Center>
    );
  }

  return (
    <Spinner size='lg' thickness='4px' speed='0.65s' emptyColor='primary.100' />
  );
};

export default Loader;
